/**
 * Specific values of placements in various sections.
 * Re-use existing values if possible. Add new values here when needed.
 * Please, add description of new placements into README.md docs.
 */
export var Placement;
/**
 * Generic product metadata shared across all
 * analytics or extended custom events.
 */

(function (Placement) {
  Placement["AddedFree"] = "added free";
  Placement["AddedWithCost"] = "added with cost";
  Placement["BambuserVideo"] = "bambuser-video";
  Placement["BeautyEditBanner"] = "beauty edit banner";
  Placement["BestOffersProducts"] = "best offers products";
  Placement["CampaignBanner"] = "campaign banner";
  Placement["CategoryListing"] = "category listing";
  Placement["CategoryInFocus"] = "category in focus";
  Placement["ConstantBenefitBanner"] = "Constant benefit banner";
  Placement["CustomerOrders"] = "customer orders";
  Placement["DigitalCatalogue"] = "digital catalogue";
  Placement["DigitalCatalogueECatalogue"] = "digital catalogue - eCatalogue";
  Placement["FavoritesSubmenu"] = "favorites submenu";
  Placement["GiftCards"] = "gift cards";
  Placement["HeroBanner"] = "hero banner";
  Placement["JoinUs"] = "join us";
  Placement["LookbookBanner"] = "lookbook banner";
  Placement["Lookbook"] = "lookbook";
  Placement["MainBasket"] = "main basket";
  Placement["MainProductDetail"] = "main product detail";
  Placement["Minibag"] = "minibag";
  Placement["MobileOfficePromoPopup"] = "mobile office - promo popup";
  Placement["MobileOfficeWhatsNew"] = "mobile office - whats new";
  Placement["NewProducts"] = "new products";
  Placement["OfferHints"] = "offer hints";
  Placement["Offers"] = "offers";
  Placement["OlapicWidget"] = "olapic widget";
  Placement["OtherProducts"] = "other products";
  Placement["PersonalProductList"] = "personal product list";
  Placement["PersonalProductListBuyAll"] = "personal product list - buy all button";
  Placement["ProductListing"] = "product listing";
  Placement["ProductSlider"] = "product slider";
  Placement["QuickOrderForm"] = "quick order form";
  Placement["RealTimeOrderTracking"] = "real time order tracking";
  Placement["RecentProducts"] = "recent products";
  Placement["RecommendedProducts"] = "recommended products";
  Placement["RelatedProducts"] = "related products";
  Placement["RewardShop"] = "reward shop";
  Placement["Samples"] = "samples";
  Placement["SelectedCategoryProducts"] = "selected category products";
  Placement["SelfRegistrationForm"] = "self-registration form";
  Placement["SetSection"] = "set section";
  Placement["SponsorRegistrationForm"] = "sponsor registration form";
  Placement["Subscriptions"] = "subscriptions";
  Placement["TopBrands"] = "top brands";
  Placement["TopCategories"] = "top categories";
  Placement["TopNavigationPopularProducts"] = "top navigation popular products";
  Placement["TopNavigationSearchSuggestions"] = "top navigation search suggestions";
  Placement["TopNavigationShopFor"] = "top navigation shop for";
  Placement["TransitionBox"] = "transition box";
  Placement["VipCustomerBenefits"] = "vip customer benefits";
  Placement["VipCustomerCheckoutRegistrationForm"] = "checkout registration form";
  Placement["Typeform"] = "typeform";
  Placement["Revieve"] = "revieve";
})(Placement || (Placement = {}));

/**
 * Specific values of shared content category.
 * Re-use existing values if possible. Add new values here when needed.
 */
export var ContentType;
/**
 * Analytics metadata extension for add-to-basket custom event.
 */

(function (ContentType) {
  ContentType["Article"] = "article";
  ContentType["Catalogue"] = "catalogue";
  ContentType["GiftCard"] = "gift card";
  ContentType["Page"] = "page";
  ContentType["Photo"] = "photo";
  ContentType["PopularQuery"] = "popular query";
  ContentType["Product"] = "product";
  ContentType["ProductList"] = "product list";
})(ContentType || (ContentType = {}));

/**
 * Specific values of actions on video.
 * Re-use existing values if possible. Add new values here when needed.
 */
export var VideoAction;

(function (VideoAction) {
  VideoAction["Start"] = "start";
  VideoAction["Progress"] = "progress";
  VideoAction["Complete"] = "complete";
})(VideoAction || (VideoAction = {}));